import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import isHorizontalAttachment from './isHorizontalAttachment';
import isVerticalAttachment from './isVerticalAttachment';

/**
 * Enforces valid horizontal and vertical attachments. If a value is missing or
 * invalid, it will be converted to center or middle.
 */
export default function parseAttachment(attachment) {
  var parsedAttachmentX;
  var parsedAttachmentY;

  var _attachment$split = attachment.split(' '),
      _attachment$split2 = _slicedToArray(_attachment$split, 2),
      attachmentX = _attachment$split2[0],
      attachmentY = _attachment$split2[1];

  if (isHorizontalAttachment(attachmentX)) {
    parsedAttachmentX = attachmentX;
  } else if (isHorizontalAttachment(attachmentY)) {
    parsedAttachmentX = attachmentY;
  } else {
    parsedAttachmentX = 'center';
  }

  if (isVerticalAttachment(attachmentY)) {
    parsedAttachmentY = attachmentY;
  } else if (isVerticalAttachment(attachmentX)) {
    parsedAttachmentY = attachmentX;
  } else {
    parsedAttachmentY = 'middle';
  }

  return [parsedAttachmentX, parsedAttachmentY];
}